import { ReactNode } from 'react';
import { Transport } from '../../graphql.generated';
import {
    FerrySmall,
    LondonUndergroundColourSmall,
    NationalRailColourSmall
} from '@zoopla-eng/zds-components/icons';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import {
    savedListingLinkStyle,
    savedListingPriceStyle,
    savedListingTransportListStyle,
    savedListingTransportsStyle
} from './ListingCardLandscape.styles.css';

// TODO: ZDSU map all POI types
const transportMap = new Map([
    ['national_rail_station', <NationalRailColourSmall />],
    ['london_underground_station', <LondonUndergroundColourSmall />],
    ['uk_ferry_port', <FerrySmall />]
]);

export const NearestTransport = ({
    transport
}: {
    transport: Transport | null;
}) => {
    if (!transport) {
        return null;
    }

    // TODO: ZDSU understand requirements, a list of one?
    const icon = transportMap.get(transport?.poiType ?? '');

    if (!icon) {
        return null;
    }

    return (
        <ul className={savedListingTransportListStyle}>
            <li
                className={savedListingTransportsStyle}
                key={`${transport.poiType}-${transport.title}`}
            >
                {icon}
                <p
                    className={fontGroups.knife}
                >{`${transport.distanceInMiles} miles from ${transport.title}`}</p>
            </li>
        </ul>
    );
};

export const ListingCardLandscapeDetail = ({
    listingLinkHref,
    onClick,
    children
}: {
    listingLinkHref?: string;
    onClick?: () => void;
    children: ReactNode;
}) => {
    return listingLinkHref ? (
        <a
            className={savedListingLinkStyle}
            href={listingLinkHref}
            onClick={onClick}
        >
            {children}
        </a>
    ) : (
        <div>{children}</div>
    );
};

export const ListingCardLandscapePrice = ({
    price
}: {
    price: string | null | undefined;
}) => {
    return price ? (
        <p className={`${savedListingPriceStyle} ${fontGroups.whisk}`}>
            {price}
        </p>
    ) : null;
};
